import React from "react";

function BibliotecaVirtualComponent({ listaBiblioteca, cursoPersona }) {
  const handleLinkClick = (event) => {
    event.preventDefault();
    const url = event.target.href;
    window.open(url, "_blank");
  };
  return (
    <div className="border rounded-9 shadow paddingBiblioteca2  p-md-4 mb-4 mb-md-4 movilBackgroundPreguntas cardTabs2 cardmr">
      <h2 className="subtitleZegel">Biblioteca virtual</h2>
      <div className="p-fluid formgrid grid">
        <div className=" col-12 md:col-10">
          <div className="field">
            <span>
              <b>Nombre del libro</b>
            </span>
          </div>
        </div>
        <div className=" col-12 md:col-2 columncard5">
          <div className="field progreso-desktop-flex">
            <span>
              <b>Link directo</b>
            </span>
          </div>
        </div>

        {listaBiblioteca.map((item, i) => {
          return (
            <>
              <div className=" col-12 md:col-10">
                <div className="field">
                  <span className="fontsizeunset">{item.nombre}</span>
                </div>
              </div>
              {/* <div className="col-12 md:col-3 columncard5">
                    <div className="field">
                      <span className="fontsizeunset">Autor</span>
                    </div>
                  </div> */}
              <div className=" col-12 md:col-2 columncard5">
                <div className="field">
                  {cursoPersona[0].idEstado != 2 &&
                    cursoPersona[0].idEstado != 1 ? (
                    <span
                      className="fontsizeunset"
                      style={{ color: "#7C7C7C" }}
                    >
                      {" "}
                      Abrir Link
                    </span>
                  ) : (
                    <a
                      href={item.linkZegel}
                      onClick={handleLinkClick}
                      className="fontsizeunset"
                      style={{
                        color: "blue",
                      }}
                    >
                      Abrir Link
                    </a>
                  )}
                </div>
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
}

export default BibliotecaVirtualComponent;
